import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';
import {sharedConfig} from './app.module.shared';
import {SharedService} from './_services/shared.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GraficasModule} from './_components/graficas/graficas.module';
import {NavMenuService} from './_services/navmenu.service';
import {DashboardService} from './_services/dashboard.service';
import {SeccionService} from './_services/seccion.service';
import {ThrobberService} from './_services/throbber.service';
import {GLMMaterialDesignModule} from './_components/material-design/material-design.module';
import {NavBarModule} from './_components/nav-bar/nav-bar.module';
import {GLMLanguageService} from './_services/glm-language.service';
import {CustomAlertService} from './_components/custom-alert/custom-alert.service';
import {GlmModalModule} from './_components/glm-modal/glm-modal.module';
import {DynamicBarModule} from './_components/dynamic-bar/dynamic-bar.module';
import {GapiPickerService} from './_services/gapi-picker';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {UserModule} from './user/user.module';
import {AsistenciaModule} from './_modules/asistencia/asistencia.module';
import {EstudioModule} from './_modules/estudio/estudio.module';
// import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {CustomAlertModule} from './_components/custom-alert/custom-alert.module';
import {JwtInterceptor} from './_helpers/jwt.interceptor';
import {ErrorInterceptor} from './_helpers/error.interceptor';
import {HomeModule} from './home/home.module';
import {ConfirmationDialogModule} from './_components/confirmation-dialog/confirmation-dialog.module';
import {MomentDateModule} from '@angular/material-moment-adapter';

import {registerLocaleData} from '@angular/common';
import localeESCO from '@angular/common/locales/es-CO';
import localeFr from '@angular/common/locales/fr';
import {LocaleInterceptor} from './_helpers/locale.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GlmResourceUploadModule } from './_components/glm-resource-upload/glm-resource-upload.module';
import { GlmActualizacionDatosModule } from './_modules/glm-actualizacion-datos/glm-actualizacion-datos.module';
import { CalendarioModule } from './_modules/calendario/calendario.module';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { ResourceViewerModalModule } from './_components/resource-viewer-modal/resource-viewer-modal.module';
import { GlmBarrasModule } from './_components/glm-barras/glm-barras.module';
// import { DragulaService } from 'ng2-dragula';

registerLocaleData(localeESCO, 'es-CO');
registerLocaleData(localeFr, 'fr');

@NgModule({ bootstrap: sharedConfig.bootstrap,
    declarations: sharedConfig.declarations,
    schemas: [], imports: [
        // Quitar
        GlmActualizacionDatosModule,
        //
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        GraficasModule,
        // AngularDraggableModule,
        ReactiveFormsModule,
        AsistenciaModule,
        CustomAlertModule,
        DynamicBarModule,
        GlmBarrasModule,
        GLMMaterialDesignModule,
        GlmModalModule,
        NavBarModule,
        EstudioModule,
        HomeModule,
        UserModule,
        // CKEditorModule,
        ConfirmationDialogModule,
        MomentDateModule,
        GlmResourceUploadModule,
        PdfJsViewerModule,
        // Quitar
        CalendarioModule,
        ResourceViewerModalModule,
        ...sharedConfig.imports], providers: [
        { provide: 'ORIGIN_URL', useValue: location.origin },
        { provide: LOCALE_ID, useValue: 'es-CO' },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LocaleInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        SharedService,
        NavMenuService,
        DashboardService,
        SeccionService,
        ThrobberService,
        GLMLanguageService,
        CustomAlertService,
        // GapiPickerService,
        Title,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
